
// src/actions/subscribe.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const SUBSCRIBE_DEVICE_TOKEN = "SUBSCRIBE_DEVICE_TOKEN"
export const SUBSCRIBE_DEVICE_TOKEN_REQUESTED = "SUBSCRIBE_DEVICE_TOKEN_REQUESTED"
export const SUBSCRIBE_DEVICE_TOKEN_COMPLETED = "SUBSCRIBE_DEVICE_TOKEN_COMPLETED"
export const SUBSCRIBE_DEVICE_TOKEN_FAILED = "SUBSCRIBE_DEVICE_TOKEN_FAILED"

export function subscribeDeviceTokenRequested() {
  return {
    type: SUBSCRIBE_DEVICE_TOKEN_REQUESTED
  }
}

export function subscribeDeviceToken(subscription_id, subscription_type, endpoint = undefined) {
  return function(dispatch) {
    dispatch(subscribeDeviceTokenRequested())
    return api.post(`/subscribe`, { subscription_id, subscription_type, endpoint })
        .then((results)=> {
          dispatch(subscribeDeviceTokenCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(subscribeDeviceTokenFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function subscribeDeviceTokenCompleted(results) {
  return {
    type: SUBSCRIBE_DEVICE_TOKEN_COMPLETED,
    results,
  }
}

export function subscribeDeviceTokenFailed(error) {
  return {
    type: SUBSCRIBE_DEVICE_TOKEN_FAILED,
    error,
  }
}




// WEBPACK FOOTER //
// ./src/actions/subscribe.js